import api from '@/utils/api'

export default {
    createSport(data) {
        return api.post(`sports`, data)
    },
    getSport(sportId) {
        return api.get(`sports/${sportId}`)
    },
    getSports(params) {
        return api.get(`sports`, { params })
    },
    updateSport(sportId, data) {
        return api.put(`sports/${sportId}`, data)
    },
    getFilteredSports(filters, page, size) {
        const params = { ...filters, page, size }
        return api.get(`sports`, { params })
    }
}
